module.exports = __webpack_public_path__ + "media/images/payments/maestro-dark-980142471e4ec88f974bddf20728cf31.svg";